import { Component, OnInit } from '@angular/core';
import { ManagedLinkKey } from 'src/common/managedLinkKey';

@Component({
  selector: 'comunidad',
  templateUrl: './comunidad.component.html',
  styleUrls: ['./comunidad.component.scss']
})
export class ComunidadComponent implements OnInit {

	cardsConfig = [
		// { title: 'Clasificados', class: 'card-clasificados', desc: 'Alquileres, automóviles, tecnología y más', key: ManagedLinkKey.CLASIFICADOS },
		{ title: 'Personas', class: 'card-personas', desc: 'Encontrá personas del Hospital Italiano', key: ManagedLinkKey.BUSQUEDA_PERSONAS },
		// { title: 'Personas', class: 'card-personas', desc: 'Encontrá personas del Hospital Italiano', key: ManagedLinkKey.BUSQUEDA_PERSONAS, routerLink: '/principal/buscador-personas' },
		{ title: 'Teléfonos', class: 'card-telefonos', desc: 'Encontrá teléfonos y números de internos', key: ManagedLinkKey.BUSQUEDA_TELEFONOS },
		// { title: 'Cumpleaños', class: 'card-cumples', desc: 'Saluda a tus compañeros y conocidos del hospital', key: ManagedLinkKey.CUMPLES, routerLink: '/principal/cumpleaños' },
		{ title: 'Fotos', class: 'card-fotos', desc: 'Mirá las imágenes de todos nuestros eventos', key: ManagedLinkKey.FOTOS }
	];

	constructor() { }

	ngOnInit() {
	}

}
